import { Value } from 'async-validator/dist-types/interface'

export const validateMatchPasswords = (
  password: string,
  value: Value,
  callback: (error?: string | Error) => void
): void => {
  if (value !== password) {
    callback(new Error('Пароли не совпадают'))
  } else {
    callback()
  }
}
